import React, { Component } from "react";
import ExperienceCard from "../../components/experienceCard/ExperienceCard.js";
import "./ExperienceAccordion.css";
import { Accordion, Panel } from "baseui/accordion";

class ExperienceAccordion extends Component {
  render() {
    const theme = this.props.theme;
    const sections = this.props.sections;

    // Filter experiences by type
    const workExperiences = sections.find(section => section.title === "Work")?.experiences || [];
    const internshipExperiences = sections.find(section => section.title === "Internships")?.experiences || [];
    const volunteershipExperiences = sections.find(section => section.title === "Volunteerships")?.experiences || [];

    return (
      <div className="experience-accord">
        <Accordion onChange={({ expanded }) => console.log(expanded)}>
          {/* Work Section */}
          {workExperiences.length > 0 && (
            <Panel className="accord-panel" title="Work" expanded={true}>
              {workExperiences.map((experience) => (
                <ExperienceCard experience={experience} theme={theme} key={experience.id} />
              ))}
            </Panel>
          )}

          {/* Internships Section */}
          {internshipExperiences.length > 0 && (
            <Panel className="accord-panel" title="Internships" expanded={true}>
              {internshipExperiences.map((experience) => (
                <ExperienceCard experience={experience} theme={theme} key={experience.id} />
              ))}
            </Panel>
          )}

          {/* Volunteerships Section */}
          {volunteershipExperiences.length > 0 && (
            <Panel className="accord-panel" title="Volunteerships" expanded={true}>
              {volunteershipExperiences.map((experience) => (
                <ExperienceCard experience={experience} theme={theme} key={experience.id} />
              ))}
            </Panel>
          )}
        </Accordion>
      </div>
    );
  }
}

export default ExperienceAccordion;
